
import { OffersPromoRepository } from "../Repository/OffersPromoRepository";

export interface UpdateBannerSingleUseCase {
    invoke: (bannerId: number, data: FormData) => Promise<boolean>;
  }
  
  export class UpdateBannerSingle implements UpdateBannerSingleUseCase {
    private Repo: OffersPromoRepository;
    constructor(_Repo: OffersPromoRepository) {
      this.Repo = _Repo;
    }
  
    async invoke(bannerId: number, data: FormData){
       
        if(!data){
            throw new Error(
                "Your todo should have at leat 2 characters."
              );
        }
         
        const update  = await this.Repo.updateBannerSingle(bannerId, data);
        return update;
    }
  }